<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col :span="5">
        <a-button type="primary" @click="adminAdd">创建</a-button>
      </a-col>
      <a-col>
        <a-form layout="inline">
          <a-form-item>
            <a-select defaultActiveFirstOption v-model="searchFrom.campus_id" placeholder="校区" style="width: 150px;">
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="item in campusList" :key="item.id" :value="item.id">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-input placeholder="教师名字" v-model="searchFrom.keyword" @keyup.enter="searchbtn"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType="submit" icon="search" @click="searchbtn"></a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <div>
      <a-table :dataSource="data" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
        @change="onPaginationChange" bordered>
        <a-table-column key="username" title="账号" data-index="username" />
        <a-table-column key="nickname" title="姓名" data-index="nickname" />
        <a-table-column key="mobile" title="手机号码" data-index="mobile" />
        <a-table-column key="email" title="电子邮件" data-index="email" />
        <a-table-column key="campusname" title="校区" data-index="campusname" />
        <a-table-column key="create_time" title="创建时间" data-index="create_time" />
        <a-table-column key="status" title="状态">
          <template slot-scope="item">
            <span v-if="item.status == 1">可用</span>
            <span v-if="item.status == 0">已禁用</span>
          </template>
        </a-table-column>
        <a-table-column key="active" title="操作">
          <template slot-scope="item">
            <a-button v-if="item.status == 0" @click="changeStatus({ id: item.id, status: 0 })" class="active_btn" size="small"
              type="link">启用
            </a-button>
            <a-button v-if="item.status == 1" @click="changeStatus({ id: item.id, status: 1 })" class="active_btn" size="small"
              type="link">禁用
            </a-button>
            <a-button v-if="item.status == 0" @click="adminDelBtn({ id: item.id, status: 1 })" class="active_btn" size="small"
              type="link">删除
            </a-button>
            <teacher-record :id="item.id"/>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :visible="visible" title="教师" @ok="save" @cancel="cancel">
      <a-form>
        <a-form-item v-if="!form.id">
          <a-input v-model="form.username" placeholder="登录账号" />
        </a-form-item>
        <a-form-item>
          <a-input type="hidden" v-model="form.id" />
          <a-input v-model="form.nickname" placeholder="姓名" />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.email" placeholder="邮箱" />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.mobile" placeholder="手机号码" />
        </a-form-item>
        <a-form-item>
          <a-select mode="multiple" placeholder="角色" v-model="form.role_ids">
            <a-select-option v-for="item in role" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="!form.id">
          <a-input v-model="form.password" placeholder="登录密码" />
        </a-form-item>
      </a-form>
    </a-modal>
  </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";

export default {
  components: { AFormItem },
  data() {
    return {
      keywords: "",
      searchFrom: {
        keyword: undefined,
        campus_id: undefined
      },
      campusList: [],
      data: [],
      role: [],
      pageinfo: { total: 1, current: 1, pageSize: 10, allCnt: 0 },
      loading: false,
      visible: false,
      form: {},
      role_visible: false,
      roleform: { role_id: "" },
      rolelist: []
    };
  },
  mounted() {
    this.getCampusList();

  },
  methods: {
    changeStatus(data) {
      this.$axios
        .post("/api/Admin/edit", { data })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.searchbtn();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    onPaginationChange(item) {
      this.pageinfo.current = item.current;
      this.getAdminList(this.searchFrom);
    },
    searchbtn() {
      this.pageinfo.current = 1;
      this.getAdminList(this.searchFrom);
    },
    getCampusList() {
      this.$axios
        .post("/api/Admin/getorgsquadlist")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campusList = res.data.org_campus;
            this.searchbtn();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getAdminList(data) {
      this.$axios
        .post("/api/OrgCampus/getteacher", {
          data,
          pageinfo: this.pageinfo
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.data = res.data.data;
            this.pageinfo = res.data.pageinfo;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    async loadrole() {
      const res = await this.$axios.post("/api/AuthRole/getrolelistorg");
      this.role = res.data;
    },
    adminEdit(item) {
      this.form.id = item.id;
      this.form.mobile = item.mobile;
      this.form.nickname = item.nickname;
      this.form.email = item.email;
      this.visible = true;
      this.loadrole();

    },

    adminAdd() {
      this.form = {};
      this.visible = true;
      this.loadrole();
    },
    adminDelBtn(data) {
      let _this = this;
      this.$confirm({
        title: "删除用户",
        content: "确认删除当前用户吗?",
        okText: "确认",
        cancelText: "取消",
        onOk: function () {
          _this.$axios
            .post("/api/OrgCampus/del", { data })
            .then(res => {
              if (res.code != 200) {
                _this.$error({
                  title: "错误",
                  content: res.msg,
                  okText: "确定"
                });
              } else {
                _this.searchbtn();
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    save() {
      // this.visible = false;
      this.$axios
        .post("/api/OrgCampus/addteacher", { data: this.form })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.searchbtn();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    cancel() {
      this.visible = false;
      this.role_visible = false;
    }
  }
};
</script>
<style>
.active_btn {
  margin-left: 5px;
}
</style>